<template>
  <table class="m-table UserForm">
    <tbody>
      <tr>
        <th colspan="2">User</th>
        <td colspan="10"><input type='text' v-model="user.user" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">name</th>
        <td colspan="10"><input type='text' v-model="user.name" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">email</th>
        <td colspan="10"><input type='text' v-model="user.email" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">type</th>
        <td colspan="10"><multiselect @select="select" v-model="watch.type" :options="type" label="name" :searchable="false" :show-labels="false" placeholder="type"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">office</th>
        <td colspan="10"><multiselect @select="select" v-model="watch.office" :options="office" label="name" :searchable="false" :show-labels="false" placeholder="office"></multiselect></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    user: Object,
    watch: Object
  },
  data () {
    return {
    }
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  computed: {
    type () {
      return this.$store.getters['users/type']
    },

    office () {
      return this.$store.getters['users/office']
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.req {
  /* background: #dffbef; */
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      /* border-bottom: solid 1px #ddd; */
      /* background: #f4f4f4; */
      background: #37474f;
      /* color: #333; */
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.UserForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// UserForm.vue?3144996c